import { Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { EAssignmentMode, OperationAssignmentResult } from './common-interfaces';

import { UtilsService } from './utils.service';

@Injectable({providedIn: 'root'})
export class OperationAssignmentsService {

  private _isInitialized = false;
  private _operationAssignments: OperationAssignmentResult[] = [];
  set operationAssignments(value: OperationAssignmentResult[]) {
    this._isInitialized = true;
    this._operationAssignments = value;
  }
  
  get operationAssignments() {
    return this._operationAssignments;
  }

  isAssigned(applicationReferenceName: string, operationName: string, mode: EAssignmentMode): boolean {

    const userAssignment = this._operationAssignments.find(x => x.applicationReferenceName === applicationReferenceName && x.operation === operationName);
    if (!userAssignment) {
      return false;
    }
    return mode === EAssignmentMode.any ? userAssignment.isAssignedToAny : userAssignment.isAssignedToAll;
  }
}
